import plugins from "./plugins"
import schema from "./schema"

export default {
  plugins,
  schema,
}
